import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchUser() {
  return axios.get(apiUrl.user.GET.DETAIL);
}

export function updateUserName(userName) {
  return axios.patch(apiUrl.user.PATCH, { user_name: userName });
}
